import {Component, OnInit} from '@angular/core';

import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateAdapter, NativeDateAdapter} from '@angular/material';

import {ProductsCategory} from './products-category';
import {ProductsArticle} from './products-article';
import {ProductsType} from './products-type';

import {AppComponent} from './app.component';

import {AuthentificationService} from './authentification.service';
import {EntrepotService} from './entrepot.service';
import {LocationService} from './location.service';
import {ProductsArticleService} from './products-article.service';
import {ProductsCategoryService} from './products-category.service';
import {SuppliersService} from './suppliers.service';

@Component({
    selector: 'my-product-insert',
    styleUrls: ['./styles/product-modify.component.css'],
    templateUrl: './templates/product-modify.component.html',
    providers: [AuthentificationService, EntrepotService, LocationService, ProductsArticleService, ProductsCategoryService, SuppliersService]
})

export class ProductMofifyComponent implements OnInit {
    operation_bt = 'ajouter';
    operation_bt2 = 'ajouter';
    serialtext: string = "";

    supplier_selected_list: Array<any> = [];
    indexofModif: number = -1;
    indexofModif2: number = -1;
    appro_min: number = 1;
    supplier_selected: any;
    disable_bt: boolean = false;
    supplier_empty: boolean = false;
    location_empty: boolean = false;

    lot_select: Array<any> = [
        {lot_value: '1', lot_answer: 'OUI'},
        {lot_value: '0', lot_answer: 'NON'}
    ];

    serial_select: Array<any> = [
        {serial_value: 'UNMANAGED_BY_SERIAL', serial_answer: 'NON GERE'},
        {serial_value: 'OUT', serial_answer: 'SORTIE'},
        {serial_value: 'IN_OUT', serial_answer: 'ENTREE/SORTIE'}
    ];

    issue_select: Array<any> = [
        {issue_value: 'FIFO', issue_answer: 'FIFO'},
        {issue_value: 'LIFO', issue_answer: 'LIFO'},
    ];

    supplier_list: Array<any> = [];
    cat_list: ProductsCategory[];
    art_list: ProductsArticle[];
    type_list: ProductsType[];
    edit_article_form: FormGroup;
    internal_code: string = '';
    indication_message = '';
    indication_message_perma = false;
    indication_message_color = false;
    showForm: boolean = true;
    disable_select_list: boolean = false;

    ischecked_for_sale = false;

    article: ProductsArticle = {
        id_article: 0,
        name: '',
        internal_code: '',
        reference_code: '',
        supplier_code: '',
        reference: '',
        type: '1',
        category: '1',
        conditioning: '',
        counting_unit: '',
        description: '',
        ht_selling_price: 0,
        supply_thershold: '',
        expiration_thershold: '0',
        managed_by_lot: '1',
        managed_by_serial: 'UNMANAGED_BY_SERIAL',
        issue_mode: 'FIFO',
        stocks: 0,
        stock_mini: 0,
        stock_maxi: 0,
        type_name: "",
    };

    format_price_ht_bying_price: string = "0";
    format_price_ht_selling_price: string = "0";
    is_selling_price_sup: boolean = false;
    expiration_th_isnotNumber: boolean = false;
    filteredSupplier: any;
    stateCtrl: FormControl;
    disable_all_supplier_operation: boolean = false;
    disable_all_location_operation: boolean = false;
    disable_select_list_location: boolean = false;

    location_capacity: any = 1;
    location_selected: any;
    location_selected_list: Array<any> = [];
    current_warehouse: string = "";
    time_limit: string = "1";
    dlc: any;
    minDate: any;
    stock_mini_isnotNumber: boolean = false;
    stock_maxi_isnotNumber: boolean = false;
    is_valid_stock_alert: boolean = false;
    is_valid_stock_maxi: boolean = false;
    price_min: string = '0';
    location_list: Array<any> = [];
    disable_bt_2: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private app_component: AppComponent,
        private location_service: LocationService,
        private products_category_service: ProductsCategoryService,
        private supplier_service: SuppliersService,
        private product_article_service: ProductsArticleService,
        private fb: FormBuilder,
        private authentification_service: AuthentificationService,
        private router: Router,
        dateAdapter: DateAdapter<NativeDateAdapter>,
        private datepipe: DatePipe,
        private entrepot_service: EntrepotService,
    ) {
        dateAdapter.setLocale('fr-FR');

        this.CheckUserSession();
        this.createForm();

        this.GetEntrepotsList();

        this.stateCtrl = new FormControl();

        // Setting Minimum dlc
        let date_now_number = Date.now();
        let date_now = this.datepipe.transform(date_now_number, 'yyyy,MM,dd');
        this.minDate = new Date(date_now);
    }

    ngOnInit(): void {
        this.GetCategoriesList();
        this.GetTypesList();
    }

    createForm() {
        this.edit_article_form = this.fb.group({
            name_ctl: ['', Validators.required],
            supplier_code_ctl: [''],
            type_ctl: ['', Validators.required],
            category_ctl: ['', Validators.required],
            conditioning_ctl: ['', Validators.required],
            counting_unit_ctl: ['', Validators.required],
            description_ctl: [''],
            ht_selling_price_ctl: ['0', Validators.required],
            supply_thershold_ctl: ['', Validators.required],
            stock_mini_ctl: ['', Validators.required],
            stock_maxi_ctl: ['', Validators.required],
            issue_ctl: ['', Validators.required],
            serial_ctl: ['', Validators.required],
            lot_ctl: ['', Validators.required],
        });
    }


    Toggle(): void {

        if (this.ischecked_for_sale === true) {
            this.ischecked_for_sale = false;
        } else {
            this.ischecked_for_sale = true;
        }
        console.log(this.ischecked_for_sale);
    }

    GetCategoriesList(): void {
        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list = cat_list);
    }

    GetTypesList(): void {
        this.product_article_service.GetTypesList().then(type_list => this.type_list = type_list);
    }

    GetSuppliersList(): void {
        this.supplier_service.GetSupplierList()
            .then(result => {
                this.supplier_list = result['list'];
                if (result['list'] !== []) {
                    this.supplier_selected = this.supplier_list[0];
                    for (let i = 0; i < this.supplier_list.length; i++) {
                        this.supplier_list[i]['status'] = 'shown';
                    }
                    this.GetArticle_cb();
                }
            });
    }

    entrepots_list: Array<any> = [];
    entrepot_selected: any = '';
    location_list_back: Array<any> = [];

    GetEntrepotsList(): void {
        this.location_selected_list = [];
        this.entrepot_service.GetEntrepots().then(result => {
            this.entrepots_list = result['list'];
            this.entrepot_selected = this.entrepots_list[0]['reference'];
            this.GetLocationList();
        });
    }

    GetLocationList(): void {
        this.location_service.getNoChildLocations().then(result => {
            this.location_list_back = result['list'];
            this.GetLocationsForThisEntrepot();
        });
        this.GetSuppliersList();
    }

    GetLocationsForThisEntrepot(): void {
        this.location_list = [];
        for (var i = 0; i < this.location_list_back.length; i++) {
            if ((this.location_list_back[i]['reference']).startsWith(this.entrepot_selected)) {
                this.location_list.push(this.location_list_back[i]);
            }
        }
        for (let i = 0; i < this.location_list.length; i++) {
            if (this.location_list[i]['status'] === "shown") {
                this.location_selected = this.location_list[i]['reference'];
                break;
            }
        }
        this.OnlyEntrepot('');
    }

    CapacityZero(value: any) {
        if (Number(value) == 0) {
            return '-';
        } else {
            return value;
        }
    }

    GetArticle_cb(): void {
        this.route.params.subscribe((params: Params) => {
            let id = params['id_article'];
            if (id !== undefined) {
                this.product_article_service.GetArticleById(id).then(result => {
                    this.article = result['article'][0];
                    this.format_price_ht_bying_price = result['article'][0]['ht_bying_price'];
                    this.format_price_ht_selling_price = result['article'][0]['ht_selling_price'];
                    if (result['article'][0]['dlc'] !== "") {
                        this.dlc = new Date(result['article'][0]['dlc']);
                    }
                    console.log(result['article'][0]['status']);
                    if(result['article'][0]['status'] === 'FOR_SALE'){
                        this.ischecked_for_sale = true;
                    }else if(result['article'][0]['status'] === ''){
                        this.ischecked_for_sale = false;
                    }
                    this.FormatPriceBying(this.format_price_ht_bying_price);
                    this.FormatPriceSelling(this.format_price_ht_selling_price);
                    if (this.article.supplier_code == 'null') {
                        this.article.supplier_code = '-';
                    }
                });
                this.GetLocationListByArticle(id);
                this.GetSupplierListByArticle(id);
            }
        });
    }

    SetIsEntrepot(value: any) {
        if (value == this.entrepot_selected) {
            return '--';
        } else {
            return value;
        }
    }

    IsEntrepot(value: any, entrepot: any) {
        if (value == entrepot) {
            return '--';
        } else {
            return value;
        }
    }

    GetSupplierListByArticle(id_article: number): void {
        this.supplier_service.GetSupplierListByArticle(id_article).then(result => {
            this.supplier_selected_list = [];
            for (let i = 0; i < result['list'].length; i++) {
                this.supplier_selected_list.push({supplier_object: result['list'][i], appro_min: parseInt(result['list'][i]['minimum_supply']), price_min: this.FormatPrice(result['list'][i]['price']), time_limit: parseInt(result['list'][i]['time_limit'])});
                var index_supplier = this.supplier_list.findIndex(supplier => supplier.id_supplier === result['list'][i]['id_supplier']);
                this.supplier_list[index_supplier]['status'] = 'hidden';
            }
            for (let i = 0; i < this.supplier_list.length; i++) {
                if (this.supplier_list[i]['status'] === "shown") {
                    this.supplier_selected = this.supplier_list[i];
                    break;
                }
            }
            this.appro_min = 1;
        });
    }

    GetLocationListByArticle(id_article: number): void {
        this.location_service.GetLocationListByArticle(id_article).then(result => {
            this.location_selected_list = [];
            for (let i = 0; i < result['list'].length; i++) {
                this.location_selected_list
                    .push({
                        id_location: result['list'][i]['id_location'],
                        capacity: result['list'][i]['capacity'],
                        location: result['list'][i]['location'],
                        entrepot: (result['list'][i]['location']).split('.')[0]
                    });
                var index_location = this.location_list_back.findIndex(location => location.id_location === result['list'][i]['id_location']);
                this.location_list_back[index_location]['status'] = 'hidden';
            }
            this.GetLocationsForThisEntrepot();
            this.location_capacity = 1;
            for (let i = 0; i < this.location_list.length; i++) {
                if (this.location_list[i]['status'] === "shown") {
                    this.location_selected = this.location_list[i]['reference'];
                    break;
                }
            }
        });
    }

    EnterStockMini(): void {
        if (isNaN(this.article.stock_mini)) {
            this.is_valid_stock_maxi = false;
            this.stock_mini_isnotNumber = true;
        } else {
            if (parseInt(this.article.stock_maxi.toString()) < parseInt(this.article.stock_mini.toString())) {
                this.is_valid_stock_maxi = true;
            } else {
                this.is_valid_stock_maxi = false;
            }
            if (parseInt(this.article.supply_thershold) < parseInt(this.article.stock_mini.toString())) {
                this.is_valid_stock_alert = true;
            } else {
                this.is_valid_stock_alert = false;
            }
        }
    }

    EnterStockAlerte(): void {
        if (isNaN(Number(this.article.supply_thershold))) {
            this.is_valid_stock_alert = false;
            this.expiration_th_isnotNumber = true;
        } else {
            this.expiration_th_isnotNumber = false;
            if (parseInt(this.article.supply_thershold) < parseInt(this.article.stock_mini.toString())) {
                this.is_valid_stock_alert = true;
            } else {
                this.is_valid_stock_alert = false;
            }
            if (parseInt(this.article.supply_thershold) > parseInt(this.article.stock_maxi.toString())) {
                this.is_valid_stock_maxi = true;
            } else {
                this.is_valid_stock_maxi = false;
            }
        }
    }

    EnterStockMaxi(): void {
        if (isNaN(this.article.stock_maxi)) {
            this.is_valid_stock_maxi = false;
            this.stock_maxi_isnotNumber = true;
        } else {
            this.stock_maxi_isnotNumber = false;
            if (parseInt(this.article.stock_maxi.toString()) < parseInt(this.article.stock_mini.toString()) || parseInt(this.article.stock_maxi.toString()) < parseInt(this.article.supply_thershold)) {
                this.is_valid_stock_maxi = true;
            } else {
                this.is_valid_stock_maxi = false;
            }
        }
    }

    putIndicationMessageColor() {
        if (this.indication_message_color) {
            if (this.indication_message_perma) {
                return "rgb(120,120,120)";
            } else {
                return "#09C6AB";
            }
        } else {
            return "#F23557";
        }
    }

    Reset(): void {
        this.edit_article_form.reset();
        this.showForm = false;
        setTimeout(() => {
            this.edit_article_form.reset();
            this.indication_message = '';
            this.is_selling_price_sup = false;
            this.article.ht_selling_price = 0;
            this.article.type = '1';
            this.article.category = '1';
            this.article.managed_by_lot = '1';
            this.article.managed_by_serial = 'UNMANAGED_BY_SERIAL';
            this.article.issue_mode = 'FIFO';
            this.article.stocks = 0;
            this.article.expiration_thershold = '0';
            this.article.stock_mini = 0;
            this.article.stock_maxi = 0;
            this.article.supply_thershold = '0';

            this.format_price_ht_selling_price = "0";
            this.expiration_th_isnotNumber = false;

            this.createForm();
            this.showForm = true;
        });
    }

    ExpirationThershold(): void {
        if (isNaN(Number(this.article.supply_thershold))) {
            this.expiration_th_isnotNumber = true;
        } else {
            this.expiration_th_isnotNumber = false;
        }
    }

    Clean(str: string): string {
        var space = String.fromCharCode(160);
        var res_1 = String(str).replace('&nbsp;', ' ');
        var res_2 = String(res_1).replace(new RegExp(space, 'gi'), ' ');
        return res_2;
    }

    CleanFormatPrice(str_price: string): number {
        var str_price = this.Clean(str_price);
        var no_space = str_price.split(' ');
        return parseInt(no_space.join(''));
    }

    FormatPriceBying(price: string): void {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            if (!isNaN(Number(clean_price))) {
                this.price_min = Math.round(clean_price).toLocaleString();
            } else {
                this.price_min = '0';
            }
        } else {
            this.price_min = '0';
        }
    }

    FormatPrice(price: string): string {
        let tmp = '';
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            if (!isNaN(Number(clean_price))) {
                tmp = Math.round(clean_price).toLocaleString();
            } else {
                tmp = '0';
            }
        } else {
            tmp = '0';
        }
        return tmp;
    }

    FormatPriceSelling(price: string): void {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            this.article.ht_selling_price = clean_price;
            if (!isNaN(Number(clean_price))) {
                this.format_price_ht_selling_price = Math.round(clean_price).toLocaleString();// + ' Ar';
            } else {
                this.format_price_ht_selling_price = "0";
                this.article.ht_selling_price = 0;
            }
        } else {
            this.format_price_ht_selling_price = "0";
            this.article.ht_selling_price = 0;
        }
    }

    ButtonOperation(element: any): void {
        if (element === 1) {
            if (this.operation_bt === "ajouter") {
                this.AddSupplier();
            } else {
                this.MofidySupplierApproMin();
            }
        } else {
            if (this.operation_bt2 === "ajouter") {
                this.AddLocation();
            } else {
                this.MofidyLocationCapacity();
            }
        }
    }

    AddSupplier(): void {
        var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
        if (index > -1) {
        }
        else {
            if (!isNaN(Number(this.appro_min)) && this.appro_min != 0) {
                this.supplier_empty = false;
                this.supplier_selected_list.push({supplier_object: this.supplier_selected, appro_min: this.appro_min, price_min: this.price_min, time_limit: this.time_limit});
                var index_supplier = this.supplier_list.findIndex(supplier => supplier.id_supplier === this.supplier_selected.id_supplier);
                this.supplier_list[index_supplier]['status'] = 'hidden';
                this.appro_min = 1;
                this.time_limit = '1';
                this.price_min = '0';

                for (let i = 0; i < this.supplier_list.length; i++) {
                    if (this.supplier_list[i]['status'] === "shown") {
                        this.supplier_selected = this.supplier_list[i];
                        break;
                    }
                }
            }
        }
        if (this.supplier_selected_list.length == this.supplier_list.length) {
            this.disable_all_supplier_operation = true;
        }
        this.IsAvalable(this.supplier_list[0]);
    }

    AddLocation(): void {
        var tmp = [];
        tmp['entrepot'] = this.entrepot_selected;
        tmp['location'] = this.location_selected;
        tmp['capacity'] = this.location_capacity;

        var index = this.location_list_back.findIndex(location => location.reference === this.location_selected);
        this.location_list_back[index]['status'] = 'hidden';
        tmp['id_location'] = this.location_list_back[index]['id_location'];
        this.GetLocationsForThisEntrepot();
        this.location_selected_list.push(tmp);

        this.OnlyEntrepot('');
        this.DisableEntrepot();
        var disable_all = 0;
        for (let i = 0; i < this.entrepots_list.length; i++) {
            if (this.entrepots_list[i]['status'] === 'hidden') {
                disable_all++;
            }
        }
        if (this.entrepots_list.length === disable_all) {
            this.entrepot_selected = -1;
            this.location_selected = -1;
            this.location_capacity = '';
            this.disable_all_entrepots_operation = true;
            this.disable_bt_2 = true;
            this.disable_capacity_location = true;
        }
        for (let i = 0; i < this.location_list.length; i++) {
            if (this.location_list[i]['status'] === "shown") {
                this.location_selected = this.location_list[i]['reference'];
                break;
            }
        }
    }

    disable_select_list_entrepot: boolean = false;
    disable_capacity_location: boolean = false;
    disable_all_entrepots_operation: boolean = false;

    DisableEntrepot() {
        var active = 0;
        for (let i = 0; i < this.location_list.length; i++) {
            if (this.location_list[i]['status'] == 'hidden') {
                active++;
            }
        }
        if (active == this.location_list.length) {
            var index2 = this.entrepots_list.findIndex(location => location.reference == this.entrepot_selected);
            this.entrepots_list[index2]['status'] = 'hidden';
            for (let i = 0; i < this.entrepots_list.length; i++) {
                if (this.entrepots_list[i]['status'] === "shown") {
                    this.entrepot_selected = this.entrepots_list[i]['reference'];
                    this.GetLocationsForThisEntrepot();
                    break;
                }
            }
        }
    }

    EnableEntrepot() {
        var active = 0;
        for (let i = 0; i < this.location_list.length; i++) {
            if (this.location_list[i]['status'] == 'hidden') {
                active++;
            }
        }
        if (active != this.location_list.length) {
            var index2 = this.entrepots_list.findIndex(location => location.reference == this.entrepot_selected);
            this.entrepots_list[index2]['status'] = 'shown';
            for (let i = 0; i < this.entrepots_list.length; i++) {
                if (this.entrepots_list[i]['status'] === "shown") {
                    this.entrepot_selected = this.entrepots_list[i]['reference'];
                    this.GetLocationsForThisEntrepot();
                    break;
                }
            }
        }
    }

    FormatCapacity(price: string): void {
        if (price !== "") {
            if (this.entrepot_selected == this.location_selected) {
                this.location_capacity = '-';
            } else {
                let clean_price = this.CleanFormatPrice(price);
                if (!isNaN(Number(clean_price))) {
                    if (clean_price == 0) {
                        this.location_capacity = '1';
                    } else {
                        this.location_capacity = Math.round(clean_price).toLocaleString();
                    }
                } else {
                    this.location_capacity = '1';
                }
            }
        } else {
            if (this.entrepot_selected == this.location_selected) {
                this.location_capacity = '-';
            } else {
                this.location_capacity = '1';
            }
        }
    }

    DeleteLocation(location: any) {
        this.location_selected = location.location;
        var tmp_loc = this.location_selected.split(".");
        this.entrepot_selected = tmp_loc[0];

        var index = this.location_selected_list.findIndex(location => location.location === this.location_selected);

        this.location_selected_list.splice(index, 1);
        var index_location = this.location_list_back.findIndex(location => location.reference === this.location_selected);
        this.location_list_back[index_location]['status'] = 'shown';
        this.GetLocationsForThisEntrepot();
        this.EnableEntrepot();
        var disable_all = 0;
        for (let i = 0; i < this.entrepots_list.length; i++) {
            if (this.entrepots_list[i]['status'] === 'hidden') {
                disable_all++;
            }
        }
        if (this.entrepots_list.length != disable_all) {
            this.location_capacity = 1;
            this.disable_all_entrepots_operation = false;
            this.disable_bt_2 = false;
            this.disable_capacity_location = false;
        }
        this.indexofModif2 = -1;
        for (let i = 0; i < this.location_list.length; i++) {
            if (this.location_list[i]['status'] === "shown") {
                this.location_selected = this.location_list[i]['reference'];
                break;
            }
        }
        this.OnlyEntrepot('');
    }

    id_location_modif: any = 0;
    EditLocation(location: any) {
        this.operation_bt2 = "valider";
        this.entrepot_selected = location.entrepot;
        this.location_selected = this.IsEntrepot(location.location, location.entrepot);
        this.id_location_modif = location.id_location;
        var temp_location_selected = location.location;
        this.location_capacity = location.capacity;

        this.indexofModif2 = this.location_selected_list.findIndex(location => location.location === temp_location_selected);

        this.disable_capacity_location = false;
        this.disable_bt_2 = false;
    }

    MofidyLocationCapacity(): void {
        if (!isNaN(Number(this.location_capacity))) {
            var index = this.indexofModif2;
            this.location_selected_list.splice(index, 1, {id_location: this.id_location_modif, entrepot: this.entrepot_selected, location: this.location_selected, capacity: this.location_capacity});
            this.location_capacity = 1;
            this.operation_bt2 = "ajouter";
            this.disable_select_list_location = false;
            this.location_selected = this.location_list[0];

            if (this.location_selected_list.length == this.location_list.length) {
                this.disable_all_location_operation = true;
            }
            this.indexofModif2 = -1;

            for (let i = 0; i < this.entrepots_list.length; i++) {
                if (this.entrepots_list[i]['status'] === "shown") {
                    this.entrepot_selected = this.entrepots_list[i]['reference'];
                    this.GetLocationsForThisEntrepot();
                    for (let k = 0; k < this.location_list.length; k++) {
                        if (this.location_list[k]['status'] === "shown") {
                            this.location_selected = this.location_list[k]['reference'];
                            break;
                        }
                    }
                    this.OnlyEntrepot('');
                    break;
                }
            }
        }
    }

    MofidySupplierApproMin(): void {
        if (!isNaN(Number(this.appro_min)) && this.appro_min != 0) {
            var index = this.indexofModif;

            this.supplier_selected_list.splice(index, 1, {supplier_object: this.supplier_selected, appro_min: this.appro_min, price_min: this.price_min, time_limit: this.time_limit});
            this.appro_min = 1;
            this.price_min = '0';
            this.time_limit = '1';
            this.operation_bt = "ajouter";
            this.disable_select_list = false;
            for (let i = 0; i < this.supplier_list.length; i++) {
                if (this.supplier_list[i]['status'] === "shown") {
                    this.supplier_selected = this.supplier_list[i];
                    break;
                }
            }
            if (this.supplier_selected_list.length == this.supplier_list.length) {
                this.disable_all_supplier_operation = true;
            }
            this.indexofModif = -1;
        }
    }

    ModifyBt(param: any, element: any): void {
        if (element === 1) {
            this.operation_bt = "valider";
            this.supplier_selected = param.supplier_object;
            this.appro_min = param.appro_min;
            this.price_min = param.price_min;
            this.time_limit = param.time_limit;
            this.indexofModif = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
            this.disable_select_list = true;
            this.disable_all_supplier_operation = false;
            this.disable_bt = false;
        }
        else if (element === 2) {

        }
    }

    SupprBt(supplier: any, element: any): void {
        if (element === 1) {
            this.supplier_selected = supplier.supplier_object;
            var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
            if (index > -1) {
                this.supplier_selected_list.splice(index, 1);

                var index_supplier = this.supplier_list.findIndex(supplier => supplier.id_supplier === this.supplier_selected.id_supplier);
                this.supplier_list[index_supplier]['status'] = 'shown';

                for (let i = 0; i < this.supplier_list.length; i++) {
                    if (this.supplier_list[i]['status'] === "shown") {
                        this.supplier_selected = this.supplier_list[i];
                        break;
                    }
                }
            }

            if (this.supplier_selected_list.length == this.supplier_list.length) {
                this.disable_all_supplier_operation = true;
            } else {
                this.disable_all_supplier_operation = false;
            }

            this.disable_bt = false;
            this.indexofModif = -1;
        } else {

        }
    }

    IsAvalable(supplier_param: any): void {
        var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === supplier_param.id_supplier);
        if (index > -1) {
            this.disable_bt = true;
        } else {
            this.disable_bt = false;
        }
    }

    EditArticle(): void {
        let supplier_list_array: Array<any> = [];
        var supplier_list_string;

        for (let i = 0; i < this.supplier_selected_list.length; i++) {
            let price_min = this.supplier_selected_list[i].price_min;
            var space = String.fromCharCode(160);
            var res_1 = String(price_min).replace('&nbsp;', '');
            var res_2 = String(res_1).replace(new RegExp(space, 'gi'), '');
            supplier_list_array[i] = this.supplier_selected_list[i].supplier_object.id_supplier + '^' + this.supplier_selected_list[i].appro_min + '^' + res_2 + '^' + this.supplier_selected_list[i].time_limit;
        }

        supplier_list_string = supplier_list_array.join('_');

        let location_list_array: Array<any> = [];
        var location_list_string;
        console.log('L799 : ' + location_list_array);
        for (let i = 0; i < this.location_selected_list.length; i++) {
            if (this.location_selected_list[i].location == '--') {
                this.location_selected_list[i].location = this.location_selected_list[i].entrepot;
            }
            if (this.location_selected_list[i].capacity == '-') {
                this.location_selected_list[i].capacity = 0;
            }
            location_list_array[i] = this.location_selected_list[i].id_location + '^' + this.location_selected_list[i].capacity + '^' + this.location_selected_list[i].entrepot + '^' + this.location_selected_list[i].location;
        }
        console.log('L809 : ' + location_list_array);
        location_list_string = location_list_array.join('_');

        let dlc = this.datepipe.transform(this.dlc, 'yyyy-MM-dd');
        this.product_article_service.EditArticle(this.article, supplier_list_string, location_list_string, dlc, this.ischecked_for_sale)
            .then(response => {
                this.router.navigate(['products-list', {id_article: this.article.id_article}]);
            });
        this.Reset();
    }

    EditArticle2() {
        let location_list_array: Array<any> = [];
        var location_list_string;
        for (let i = 0; i < this.location_selected_list.length; i++) {
            if (this.location_selected_list[i].location == '--') {
                this.location_selected_list[i].location = this.location_selected_list[i].entrepot;
            }
            location_list_array[i] = this.location_selected_list[i].id_location + '^' + this.location_selected_list[i].capacity + '^' + this.location_selected_list[i].entrepot + '^' + this.location_selected_list[i].location;
        }
        location_list_string = location_list_array.join('_');
    }

    ValideModification(): void {
        if (this.edit_article_form.status == 'VALID' && this.expiration_th_isnotNumber === false && this.stock_mini_isnotNumber === false && this.stock_maxi_isnotNumber == false && this.supplier_selected_list.length > 0 && this.location_selected_list.length > 0) {
            this.EditArticle();
        }
        else {
            this.indication_message_color = false;
            if (this.supplier_selected_list.length == 0) {
                this.supplier_empty = true;
            }
            if (this.location_selected_list.length == 0) {
                this.location_empty = true;
            }
            this.indication_message = 'PROBLEME D\'INSERTION, VEUILLEZ VERIFIER LES CHAMPS!';
            setTimeout(() => {this.indication_message = ""}, 3000);
        }
    }

    CancelModification(): void {
        this.router.navigate(['products-list']);
    }

    SetStyle(value: any, element: number) {
        let styles = {
            'background-color': '',
            'color': 'black',
        };
        if (value == this.indexofModif && element === 1) {
            styles = {
                //                'background-color': '#3f3f3f',
                'background-color': 'rgb(120,120,120)',
                'color': 'white',
            };
        }
        else if (value == this.indexofModif2 && element === 2) {
            styles = {
                //                'background-color': '#3f3f3f',
                'background-color': 'rgb(120,120,120)',
                'color': 'white'
            };
        }
        return styles;
    }

    CheckUserSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification']);
                }
            });
    }

    OnlyEntrepot(event: any) {
        if (this.location_selected == this.entrepot_selected) {
            this.location_capacity = '-';
        } else {
            this.location_capacity = 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/product-modify.component.ts